import debounce from "lodash-es/debounce"

const $disableMobileTooltip = $("[data-tooltip=disable-mobile-tooltip]")
const $box = $("[data-tooltip=box]")
const $wrapper = $("[data-tooltip=wrapper]")
const $close = $("[data-tooltip=close]")
const $contentReceiver = $("[data-tooltip=content-receiver]")
const $contentSource = $("[data-tooltip=content-source]")
const $open = $("[data-tooltip=open]")
const $window = $(window)
let self
let sourceContent
let windowWidth

const openTooltip = (self) => {
  $wrapper.addClass("_is-active")
  sourceContent = self.find($contentSource).text()
  $contentReceiver.text(sourceContent)
}

const closeTooltip = () => {
  $wrapper.removeClass("_is-active")

  setTimeout(() => {
    $contentReceiver.text("")
  }, 300)
}

const initMobileTooltip = () => {
  windowWidth = $window.width()

  if (windowWidth <= 768 || windowWidth < 1024) {
    $open.on("click", (event) => {
      self = $(event.currentTarget)
      openTooltip(self)
    })

    $close.on("click", closeTooltip)
  } else {
    $open.off("click")
    $close.off("click")
  }
}

$(() => {
  // Таким способом решаем проблему блинка на полсекунды у этих блоков при загрузке страницы
  setTimeout(() => {
    if ($wrapper.length !== 0 && $disableMobileTooltip.length === 0) {
      $wrapper.css({ display: "block" })
      $window.on(
        "resize load",
        debounce(initMobileTooltip, 300, { trailing: true, leading: false }),
      )
    }

    if ($box.length !== 0) {
      $box.css({ display: "block" })
    }
  }, 800)
})



// WEBPACK FOOTER //
// ./src/blocks/tooltip/tooltip.js